const $ = jQuery;

const LoadMore = {
  getHashFilter: () => {
    var matches = location.hash.match(/filter=([^&]+)/i);
    var hashFilter = matches && matches[1];
    return hashFilter && decodeURIComponent(hashFilter);
  },
  init: function () {
    const isotopGrid = $(".image-group");
    isotopGrid.isotope({
      layoutMode: "fitRows",
      itemSelector: ".gallery-img",
    });
    const initHash = LoadMore.getHashFilter();
    if(initHash && initHash != ""){
      isotopGrid.isotope({
         filter: initHash == "gallery-cat-all" ? "*" : `.${initHash}`,
       });
       $(".gallery-category").removeClass("active");
       $(".gallery-category#"+initHash).addClass("active");
      
    }
    $(".gallery-category").on("click", function () {
      const _this = $(this);
      const parent = _this.parent();
      const allItems = parent.find(".gallery-category");
      allItems.removeClass("active");
      _this.addClass("active");
      const filterClass = _this.attr("id");
      isotopGrid.isotope({
        filter: filterClass == "gallery-cat-all" ? "*" : `.${filterClass}`,
      });
      location.hash = "filter=" + encodeURIComponent(filterClass);
    });
  },
};

export default LoadMore;
